import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

const configRoute = {
  segment: 'config',
  element: lazyModulePage('core', () => import('@/soluqr/modules/core/screens/ConfigPage')),
};

const menuDesignRoute = {
  segment: 'design',
  element: lazyModulePage('core', () => import('@/soluqr/modules/core/screens/MenuDesignPage')),
};

const qrRoute = {
  segment: 'qr',
  element: lazyModulePage('core', () => import('@/soluqr/modules/core/screens/QRCodesPage')),
};

const membershipRoute = {
  segment: 'membership',
  element: lazyModulePage('core', () => import('@/soluqr/modules/core/screens/MembershipPage')),
};

const supportRoute = {
  segment: 'support',
  element: lazyModulePage('core', () => import('@/soluqr/modules/core/screens/SupportPage')),
};

export const coreRouteElements = [
  configRoute,
  menuDesignRoute,
  qrRoute,
  membershipRoute,
  supportRoute,
];

export const coreConfigRoute = configRoute;
export const coreMenuDesignRoute = menuDesignRoute;
export const coreQrRoute = qrRoute;
export const coreMembershipRoute = membershipRoute;
export const coreSupportRoute = supportRoute;
